import React from "react";
import { Step8ScheduleReserveContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import queryString from "query-string";
import { userService } from "apiServices";
import { withTranslation } from "react-i18next";
import { HeaderBackMusicHallWidget } from "widgets";
import { Forms, Headers, Displays, Navigations } from "components";
class Step8ScheduleReserveContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { router, i18n } = this.props;
    let res = await userService.GET_EQUIPMENT_LIST(`?pagination=false&type=2`);
    if (res && res.status === 200) {
      this.setState({
        equipmentOptions: res.data.docs
          .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
          .map((e) => ({
            label: i18n.language === "en" ? e.name_en : e.name_th,
            value: e._id,
          })),
        initialValues: {
          ...queryString.parse(router.location.search),
          additional_equipment_additional:
            queryString
              .parse(router.location.search)
              .additional_equipment_additional?.split(",") || [],
        },
        isLoading: false,
      });
    }
  };

  handleBack = () => {
    const { router } = this.props;
    const { id } = this.props.router.params;
    this.props.router.navigate(
      `${ROUTE_PATH.MUSIC_HALL}/${id}/booking/7${router.location.search}`,
    );
  };

  handleSubmit = (values) => {
    const { initialValues } = this.state;
    const { id } = this.props.router.params;
    const queryString = new URLSearchParams({
      ...initialValues,
      ...values,
    }).toString();
    this.props.router.navigate(
      `${ROUTE_PATH.MUSIC_HALL}/${id}/booking/9?${queryString}`,
    );
  };

  render() {
    const { router, t } = this.props;
    const isPreview =
      queryString.parse(router.location.search)?.is_preview === "true";
    const { isLoading, equipmentOptions, initialValues } = this.state;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Music Hall Bangkok", { ns: "common" }),
        path: `${ROUTE_PATH.MUSIC_HALL_AND_PRACTICE}/6913fddf8682dc3a88f16b7c`,
      },
    ];
    return (
      <Step8ScheduleReserveContainerStyled isPreview={isPreview}>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="step_schedule_reserve_container">
          {!isPreview ? (
            <div className="header_layout">
              <Headers.NewPageHeader
                title={"YAMAHA MUSIC  HALL, BANGKOK"}
                sub_title={"Rental Registration form "}
              />
            </div>
          ) : (
            <div className="header_backhome_layout">
              <HeaderBackMusicHallWidget room_booking_id={router.params.id} />
            </div>
          )}
          {isPreview && (
            <div className="title_preview">
              {t("Review Information", { ns: "common" })}
            </div>
          )}
          <div className="detail_layout">
            <Displays.TitleReserve
              title_reserve={`6. ${t("Additional Equipment (Optional Extras)", {
                ns: "room",
              })}`}
            />
          </div>
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <Forms.MusicHallRegisEquipmentAdditionalForm
              isDisabledForm={isPreview}
              initialValues={initialValues}
              equipmentOptions={equipmentOptions}
              onBack={this.handleBack}
              onSubmit={this.handleSubmit}
            />
          )}
        </div>
      </Step8ScheduleReserveContainerStyled>
    );
  }
}

export default withTranslation(["common", "room"])(
  withRouter(Step8ScheduleReserveContainer),
);
